/**
 * @author NikolaV
 */

import * as React from 'react';
import { observer } from 'mobx-react';
import { Dropdown } from '@shared/ui-react/Dropdown';
import { MapTileLayers } from '@openlayers/tile-layers/MapTileLayers';


@observer
export class TileLayersDropdown extends React.Component<{
    mapTileLayers: MapTileLayers,
    children?: React.ReactNode
}> {
    render() {
        const mapTileLayers = this.props.mapTileLayers;

        const items = mapTileLayers.layersDefinitions.map(def => ({
            label: def.name,
            value: def.uuid,
            readOnly: def.readOnly
        }));

        const multipleSelected = mapTileLayers.activeUuids.length > 1;
        const activeItem = multipleSelected ? null : items.find(i => i.value == mapTileLayers.activeUuids[0]);
        const opacity = activeItem ? mapTileLayers.opacities[mapTileLayers.activeUuids[0]] : 100;

        return (
            <>
                <Dropdown closeOnBodyClick={true} position='right'>
                    <>
                        <span>{activeItem ? activeItem.label : (multipleSelected ? __('js_map.n_tile_layers_selected', mapTileLayers.activeUuids.length) : __('js_map.no_tile_layers_selected'))}</span> <i className='iconf-caret'></i>
                    </>

                    <div>
                        {this.props.children}
                        <div>
                            <div className='dropdown-list-title'>{kuura.getMessage('js_map.tile_layer_opacity')}:</div>
                            <div className='flex-row ai-center' style={{ padding: '0 20px', opacity: multipleSelected ? 0.2 : 1 }}>
                                <input type='range' min={20} max={100} step={10} value={opacity} disabled={multipleSelected}
                                       onChange={e => mapTileLayers.setOpacity(mapTileLayers.activeUuids[0], parseInt(e.currentTarget.value))}/>
                                <strong style={{ width: '3em' }}> {opacity}%</strong>
                            </div>
                        </div>
                        <div className='dropdown-list-title'>{kuura.getMessage('js_map.tile_layer')}:</div>
                        <ul className='dropdown-list clickable' style={{ maxHeight: '70vh', maxWidth: 900, paddingRight: 5 }}>
                            {items.map(i => (
                                <li onClick={() => mapTileLayers.activateByIdOrUuid(i.value, true, opacity)} key={i.value}>
                                    <input type='radio' checked={mapTileLayers.activeUuids.includes(i.value)} readOnly={true}/> <span>{i.label}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </Dropdown>

                { mapTileLayers.hasConnectionProblem && <div className='flex-row ai-center' style={{ margin: '0 3px 0 7px', cursor: 'default' }}>
                    <span className='badge badge-warning' title={kuura.getMessage('js_map.layers.connection_problems')}>!</span>
                </div>}
            </>
        );
    }
}
